'use strict'

/**
 * Module LocalStorage pour la wishlist
 */

const ARTICLE_WISHLIST = 'articleswishlist'

/**
 * Initialise la wishlist dans le localStorage
 * @param {boolean} force Force l'appel api pour la récupération de la wishlist
 */
export function InitialiserWishlistInLocalStorage(force) {
    if (
        window.location.search.indexOf('id') != -1 &&
        window.location.search.indexOf('key') != -1
    ) {
        force = true
    }

    if ($('.j_user_notconnected').length != 0) {
        nettoyer()
    } else {
        const data = localStorage.getItem(ARTICLE_WISHLIST)

        if (force === true || data === null) {
            $.ajax({
                url: '/WishList/GetArticles',
                success: function (data) {
                    try {
                        if (data != null && data.length > 0) {
                            localStorage.setItem(
                                ARTICLE_WISHLIST,
                                JSON.stringify(data)
                            )

                            afficheWishlistCatalogue()
                        } else {
                            localStorage.setItem(
                                ARTICLE_WISHLIST,
                                JSON.stringify([])
                            )
                        }
                    } catch (QuotaExceededError) {
                        //TODO Gestion du LocalStorage plein
                    }
                }
            })
        } else {
            afficheWishlistCatalogue()
        }
    }
}

function afficheWishlistCatalogue() {
    const listeArticle = JSON.parse(localStorage.getItem(ARTICLE_WISHLIST))

    if (listeArticle !== null) {
        listeArticle.forEach(function (article, index) {
            let item = $(
                ".wishListItem[data-refmodele='" +
                    article.RefModele +
                    "'][data-couleur='" +
                    article.CodeCouleur +
                    "']"
            )
            if (item !== undefined && item.length > 0) {
                item.data('id', article.Id)
                item.attr('data-id', article.Id)
                item.addClass('is-wishlist')
            }
        })
    }
}

function ajouterArticleWishList(article) {
    if (article.Id !== 0) {
        const liste = JSON.parse(localStorage.getItem(ARTICLE_WISHLIST))

        if (liste == null) {
            InitialiserWishlistInLocalStorage(true)
        } else {
            liste.push(article)
            localStorage.setItem(ARTICLE_WISHLIST, JSON.stringify(liste))
            afficheWishlistCatalogue()
        }
    } else {
        InitialiserWishlistInLocalStorage(true)
    }
}

/**
 * Supprime un élément dans la wishlist et réaffiche la wishlist catalogue
 * @param {string} articleId Id de l'article
 */
export function SupprimerArticleWishListInLocalStorage(articleId) {
    if (articleId === 0) {
        return
    }
    const wishlist = JSON.parse(localStorage.getItem(ARTICLE_WISHLIST))

    if (wishlist == null) {
        return
    }

    wishlist.forEach(function (element, index) {
        if (element.Id === articleId) {
            wishlist.splice(index, 1)
            localStorage.setItem(ARTICLE_WISHLIST, JSON.stringify(wishlist))
            return
        }
    })

    afficheWishlistCatalogue()
}

function nettoyer() {
    localStorage.removeItem(ARTICLE_WISHLIST)
}

export default {
    ajouterArticleWishList: ajouterArticleWishList
}
